import type { AutomationCategoryResponse } from '@reach/shared-types/automation-category';
import { MoreHorizontal } from 'lucide-react';
import { CategoryPill } from '../CategoryPill/CategoryPill';

interface CategoryOptionRowProps {
  category: AutomationCategoryResponse;
  isSelected: boolean;
  canSelectMore: boolean;
  onToggle: () => void;
  onEdit: () => void;
}

/** One category in the picker menu, with a checkbox and an edit button. Used by CategoryChecklist. */
export function CategoryOptionRow({
  category,
  isSelected,
  canSelectMore,
  onToggle,
  onEdit,
}: CategoryOptionRowProps) {
  const isBlockedByLimit = !isSelected && !canSelectMore;
  const editLabel = `Edit ${category.name}`;

  return (
    <li>
      <label>
        <input type="checkbox" checked={isSelected} disabled={isBlockedByLimit} onChange={onToggle} />
        <CategoryPill category={category} />
      </label>
      <button type="button" aria-label={editLabel} onClick={onEdit}>
        <MoreHorizontal aria-hidden />
      </button>
    </li>
  );
}
